import LineInterface from 'app/interfaces/LineInterface';

export const formVsTitle = (line: LineInterface): string => `${line.gamer_1.nick} vs ${line.gamer_2.nick}`;
